import React, { PropTypes, Component } from 'react';
import uuid from 'uuid';
import L from 'leaflet';
import { featureLayer, basemapLayer } from 'esri-leaflet';
import 'leaflet/dist/leaflet.css';
import './LeafletMap.css';
import hgIcon from '../assets/icons/hydrogeology-icon.png';
import bgcIcon from '../assets/icons/biogeochemistry-icon.png';
import vIcon from '../assets/icons/vegetation-icon.png';
import cIcon from '../assets/icons/climate-icon.png';
import mIcon from '../assets/icons/modeloutput-icon.png';
import ecoIcon from '../assets/icons/vegetation-icon.png';

const icons = {
    hydrogeology: [0, hgIcon],
    ecohydrology: [1, ecoIcon],
    biogeochemistry: [2, bgcIcon],
    vegetation: [3, vIcon],
    climate: [4, cIcon],
    modeloutput: [5, mIcon]
};

const legendColors = {
    alpine:"#261447",
    subalpine:"#FF3864",
    montane:"#9999CC",
    foothills:"#F6BD60",
    plains:"#EDEDE6"
};



class LeafletMap extends Component {

    constructor(props) {
        super(props);
        this.state = {
            map: null,
            mapId: uuid.v4(),
            activeSite: null,
            focusOnSite: props.hasOwnProperty("focusOnSite") ? props.focusOnSite : false
        };

        this.layers = {
            markersLayer: null,
            basemapLayer: null
        };
        
        if (props.markerActivated) {
            this.markerActivated = props.markerActivated.bind(this);
        }
        else {
            this.markerActivated = function (feature) {
                this.setState({activeSite: feature});
            }
        }
        
        this.getBounds = this.getBounds.bind(this);
        this.onEachFeature = this.onEachFeature.bind(this);
        this.pointToLayer = this.pointToLayer.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.onZoomEnd = this.onZoomEnd.bind(this);
    }

    noop() {
        //
/*



watershed_sfa.zones.loaded = false;

watershed_sfa.zones.toggle = function() {
    if (!watershed_sfa.zones.loaded) {
        watershed_sfa.map.addLayer(watershed_sfa.zones.layer);
        watershed_sfa.map.addControl(watershed_sfa.zones.legend.control);
    }
    else {
        watershed_sfa.map.removeLayer(watershed_sfa.zones.layer);
        watershed_sfa.map.removeControl(watershed_sfa.zones.legend.control);
    }

    watershed_sfa.zones.loaded = !watershed_sfa.zones.loaded;
}
*/
    }
    
    onDragEnd(e) {
        //
    }
    
    onZoomEnd(e) {
        //
    }
    
    getBounds(sites) {
        let bounds = [[90.0,180.0],[-90.0,-180.0]];
        let lat, lon;
        // compute a bounding box to fit the current sites
        for (let i = sites.features.length - 1; i >= 0; i--) {
            lat = sites.features[i].geometry.coordinates[1];
            lon = sites.features[i].geometry.coordinates[0];
            if (lat > bounds[1][0]) {
                bounds[1][0] = lat;
            }
            if (lat < bounds[0][0]) {
                bounds[0][0] = lat;
            }
            if (lon > bounds[1][1]) {
                bounds[1][1] = lon;
            }
            if (lon < bounds[0][1]) {
                bounds[0][1] = lon;
            }
        }
        
        let buffer = 0.001;
        // pad the bounds to not clip sites near the edge
        bounds[0][0] -= buffer;
        bounds[1][0] += buffer;
        bounds[0][1] -= buffer;
        bounds[1][1] += buffer;
        
        return bounds;
    }

    pointToLayer(feature, latlng) {
        let html = "";
        let categories = feature.properties.measurement_categories.sort(function (a, b) {
            if (icons.hasOwnProperty(a) && icons.hasOwnProperty(b)) {
                return icons[a][0] - icons[b][0];
            }
            else {
                let unknownCategories = [];
                if (!icons.hasOwnProperty(a)) {
                    unknownCategories.push(a);
                }
                if (!icons.hasOwnProperty(b)) {
                    unknownCategories.push(b);
                }
                throw Error("Unrecognized measurement categories: " + unknownCategories);
            }
        });
        let numIcons = 0;
        let iconSize = [32,20];
            
        for (let i = 0; i < categories.length; i++) {
            if (icons.hasOwnProperty(categories[i])) {
                html += "<img class='measurement-icon' id='" + feature.id + "-icon' src='" + icons[categories[i]][1] + "'/>";
                numIcons += 1;
            }
        }
        
        if (numIcons > 1) {
            iconSize[0] = 28 * numIcons;
        }
        
        return L.marker(latlng,
                        {icon: L.divIcon({
                             className: 'custom-div-icon',
                             iconSize: iconSize,
                             html: html
                             }
                        )}
        );
    }

    onEachFeature(feature, layer) {
        const self = this;
        
        layer.on('mouseover', function(evt) {
            evt.target.bindPopup(L.popup().setContent("<div>" + feature.id + "</div>")).openPopup();
        });
        layer.on('mouseout', function(evt) {
            evt.target.closePopup();
        });
        layer.on('click', function(evt) {
            self.markerActivated(feature);
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.map && this.layers.markersLayer) {
            let map = this.state.map;
            
            if (nextProps.sites === this.props.sites) {                
                if (this.state.activeSite && this.state.activeSite.id !== nextProps.activeSite.id) {
                    //document.getElementsByClassName("custom-div-icon-activated")
                    
                    //console.log(document.getElementById(this.state.activeSite.id + "-icon").parentElement.className.replace("custom-div-icon-activated",""));
                    // clear state of last active icon
                    document.getElementById(this.state.activeSite.id + "-icon").parentElement.className = document.getElementById(this.state.activeSite.id + "-icon").parentElement.className.replace(new RegExp("custom-div-icon-activated", 'g'),"");
                    // set new active icon state
                    document.getElementById(nextProps.activeSite.id + "-icon").parentElement.className += " custom-div-icon-activated";
                }

                this.setState({activeSite: nextProps.activeSite});                
                return;
            }
            
            map.removeLayer(this.layers.markersLayer);
            this.layers.markersLayer = L.geoJSON(nextProps.sites,{
                pointToLayer: this.pointToLayer,
                onEachFeature: this.onEachFeature
            });
            map.addLayer(this.layers.markersLayer);
            if (nextProps.activeSite && !document.getElementById(nextProps.activeSite.id + "-icon").parentElement.className.includes("custom-div-icon-activated")) {
                document.getElementById(nextProps.activeSite.id + "-icon").parentElement.className += " custom-div-icon-activated";
            }
            
            map.fitBounds(this.getBounds(nextProps.sites), {animate: true});
            this.setState({map: map, activeSite: nextProps.activeSite});
        }
    }

    componentDidUpdate() {
        const map = this.state.map;
        if (map) {
            map.invalidateSize(false);
        }
    }
    
    componentDidMount() {
        const map = L.map(this.state.mapId, {renderer: L.canvas()});

        let esriLayers = [
            basemapLayer("Topographic", {maxNativeZoom: 19, maxZoom: 24}),
            basemapLayer("NationalGeographic", {maxNativeZoom: 16, maxZoom: 24, zoom: 18}),
            basemapLayer("Terrain", {maxNativeZoom: 13, maxZoom: 24}),
            basemapLayer("USATopo", {maxNativeZoom: 15, maxZoom: 24}),
            basemapLayer("ShadedRelief", {maxNativeZoom: 13, maxZoom: 24}),
            basemapLayer("Imagery", {maxNativeZoom: 19, maxZoom: 24})
        ];

        let baseMaps = {
            "Topographic": esriLayers[0],
            "NationalGeographic": esriLayers[1],
            "Terrain": esriLayers[2],
            "USATopo": esriLayers[3],
            "ShadedRelief": esriLayers[4],
            "Imagery": esriLayers[5]
        };

        let zonesLegend = L.control({position: 'topright'});
        zonesLegend.onAdd = function(map) {
            this._div = L.DomUtil.create('div', 'legend');        
            this._div.innerHTML += '<div id="zonesLegend">' +
                '<div class="legend-color" style="background:' + legendColors.alpine + '"></div>' +
                '<div class="legend-label">Alpine</div>' +
                '<div class="legend-color" style="background:' + legendColors.subalpine + '"></div>' +
                '<div class="legend-label">Sub-Alpine</div>' +
                '<div class="legend-color" style="background:' + legendColors.montane + '"></div>' +
                '<div class="legend-label">Montane</div>' +
                '<div class="legend-color" style="background:' + legendColors.foothills + '"></div>' +
                '<div class="legend-label">Foothills</div>' +
                '<div class="legend-color" style="background:' + legendColors.plains + '"></div>' +
                '<div class="legend-label">Plains</div>' +
                '</div>';
            return this._div;
        };
        let zonesLayer = featureLayer({
            url: "https://services4.arcgis.com/jzlMsmscSx37zEbh/arcgis/rest/services/Colorado_Lifezones/FeatureServer/0",
            renderer: L.canvas(),
            cacheLayers: true,
            style: function(feature) {
                if (!feature.hasOwnProperty('properties')) {
                    return;
                }

                if (feature.properties.Name === "Alpine") {
                    return {color: legendColors.alpine, weight: 1, fillOpacity: 0.5};
                }
                else if (feature.properties.Name === "Sub-Alpine") {
                    return {color: legendColors.subalpine, weight: 1, fillOpacity: 0.5};
                }
                else if (feature.properties.Name === "Montane") {
                    return {color: legendColors.montane, weight: 1, fillOpacity: 0.5};
                }
                else if (feature.properties.Name === "Foothills") {
                    return {color: legendColors.foothills, weight: 1, fillOpacity: 0.5};
                }
                else if (feature.properties.Name === "Plains") {
                    return { color: legendColors.plains, weight: 1, fillOpacity: 0.5};
                }
                else {
                    return null;
                }
            }
        });
        let zonesLoading = L.control({position: 'topright'});
        zonesLoading.onAdd = function(map) {
            let div = L.DomUtil.create('div', 'loading');
            div.innerHTML += '' +
                '<span class="glyphicon-left glyphicon glyphicon-refresh spinning"></span>' +
                '<span class="loading-text">Loading</span>';
            return div;
        };

        zonesLayer.on('load', function (evt) {
            zonesLoading.remove(map); 
        });
        
        map.on('overlayadd', function (eventLayer) {
            if (eventLayer.name === "Life Zones") {
                zonesLoading.addTo(map);
                zonesLegend.addTo(map);
            }
        });
        
        map.on('overlayremove', function (eventLayer) {
            if (eventLayer.name === "Life Zones") {
                zonesLegend.remove(map);
            }
        });
        
        L.control.layers(baseMaps, {"Life Zones": zonesLayer}, {position: 'topleft'}).addTo(map);
        L.control.scale({position: 'topright'}).addTo(map);
        
        if (this.state.focusOnSite) {
            const bounds = [
                             [this.props.activeSite.geometry.coordinates[1] - 1.0,
                              this.props.activeSite.geometry.coordinates[0] - 1.0],
                             [this.props.activeSite.geometry.coordinates[1] + 1.0,
                              this.props.activeSite.geometry.coordinates[0] + 1.0]
                           ];
            this.layers.basemapLayer = baseMaps["NationalGeographic"];
            map.addLayer(this.layers.basemapLayer);
            map.invalidateSize(false).fitBounds(bounds).setView({
                lon: this.props.activeSite.geometry.coordinates[0],
                lat: this.props.activeSite.geometry.coordinates[1]
            }, 16);
            this.layers.markersLayer = L.geoJSON(this.props.sites,{
                pointToLayer: this.pointToLayer,
                onEachFeature: this.onEachFeature
            });
            map.addLayer(this.layers.markersLayer);
            document.getElementById(this.props.activeSite.id + "-icon").parentElement.className += " custom-div-icon-activated";
        }
        else {
            map.invalidateSize(false).fitBounds(this.getBounds(this.props.sites));

            if (this.layers.markersLayer !== null && map.hasLayer(this.layers.markersLayer)) {
                map.removeLayer(this.layers.markersLayer);
            }

            if (this.layers.basemapLayer === null) {
                this.layers.basemapLayer = baseMaps["NationalGeographic"];
                map.addLayer(this.layers.basemapLayer);
            }

            this.layers.markersLayer = L.geoJSON(this.props.sites,{
                pointToLayer: this.pointToLayer,
                onEachFeature: this.onEachFeature
            });
            map.addLayer(this.layers.markersLayer);
            if (!document.getElementById(this.props.activeSite.id + "-icon").parentElement.className.includes("custom-div-icon-activated")) {
                document.getElementById(this.props.activeSite.id + "-icon").parentElement.className += " custom-div-icon-activated";
            }
        }

        this.setState(function(prevState, props) {
            return {map: map, activeSite: this.props.activeSite};
        });
    }
            
    render() {
        const map = this.state.map;
        const mapId = this.state.mapId;

        return (
            <div id={mapId} className="map">
                { map && this.props.children }
            </div>
        );
    }
}

LeafletMap.propTypes = {
    zoom: PropTypes.number,
    sites: PropTypes.object,
    activeSite: PropTypes.object,
    focusOnSite: PropTypes.bool
};

export default LeafletMap;


// WEBPACK FOOTER //
// ./src/map/LeafletMap.js